import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useCallback, createElement } from 'react';
import clsx from 'clsx';
import { getIconSize, buttonVariantToIconColorMap } from './utils.js';
import { useBaseButtonContext } from './base-button-context.js';
import styles from './base-button.module.js';
var BaseButtonIcon = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _clsx;

  var icon = props.icon,
      iconProps = props.iconProps;

  var _useBaseButtonContext = useBaseButtonContext(),
      loading = _useBaseButtonContext.loading,
      size = _useBaseButtonContext.size,
      variant = _useBaseButtonContext.variant,
      isIconButton = _useBaseButtonContext.isIconButton,
      ariaLabel = _useBaseButtonContext.ariaLabel;

  var renderIcon = useCallback(function () {
    if (!icon) {
      return null;
    }

    if (isIconButton && !ariaLabel) {
      // eslint-disable-next-line no-console
      console.warn('Icon only button must have an aria-label');
      return null;
    }

    return /*#__PURE__*/createElement(icon, _objectSpread(_objectSpread({}, getIconSize(size, isIconButton)), {}, {
      color: loading ? 'transparent' : buttonVariantToIconColorMap[variant],
      role: 'presentation'
    }, iconProps));
  }, [icon, size, loading, variant, isIconButton, iconProps, ariaLabel]);
  return jsx("span", {
    ref: forwardedRef,
    className: clsx(styles.icon, (_clsx = {}, _defineProperty(_clsx, styles.isIconButton, isIconButton), _defineProperty(_clsx, styles.loading, loading), _clsx)),
    children: renderIcon()
  });
});
BaseButtonIcon.displayName = 'BaseButton.Icon';
export { BaseButtonIcon };